/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import DialogModal from "../DialogModal/DialogModal";

type StatusDivorceModalProps = {
  open: boolean;
  onClose: () => void;
};

const StatusDivorceModal = ({ open, onClose, ...rest }: StatusDivorceModalProps) => {
  return (
    <DialogModal open={open} onClose={onClose} {...rest} title={"Einvernehmliche Scheidung oder Streitpunkte"}>
      <p>Wenn Sie und Ihr Ehepartner sich über die Scheidung einig und alle Punkte geklärt sind, handelt es ich um eine einvernehmliche Scheidung.</p>
      <p>
        Wenn es noch offene Streitpunkte gibt, geben Sie dies bitte an. Beispiele für Streitpunkte sind insbesondere der Unterhalt, Vermögen, Hausrat, Wohnung
        und ggf. das Sorgerecht für gemeinsame Kinder.
      </p>
      <p>
        Wenn Sie sich bei einzelnen Themen noch unsicher sind, wählen Sie "Ich bin mir nicht sicher" aus und wir klären die Punkte gemeinsam telefonisch ab.
      </p>
    </DialogModal>
  );
};

export default StatusDivorceModal;
